import React from 'react';
import { Avatar, useTheme } from '@mui/material';
import {
  ACTIVITY_TYPES_COLORS,
  ACTIVITY_TYPES_ICONS,
} from '../Utils/constants/activityTypes';

const ActivityTypeAvatar = function ActivityTypeAvatar({
  activityType,
  size = '46px',
}) {
  const theme = useTheme();
  const Icon = ACTIVITY_TYPES_ICONS[activityType];

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        fontSize: '1.25rem',
        ...theme.custom.bgAndColorStyle(
          ACTIVITY_TYPES_COLORS[activityType] ?? theme.palette.primary.main,
          theme.palette.mode
        ),
      }}
    >
      {Icon && <Icon sx={{ color: 'inherit', fontSize: 'inherit' }} />}
    </Avatar>
  );
};

export default ActivityTypeAvatar;
